var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn--bare pointer-area flex",class:_vm.classes,on:{"click":_vm.handleClick}},[_c('div',{staticClass:"toolbar-button",style:(_vm.style)},[(_vm.hasIcon)?_c('icon'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }